import { useState, useLayoutEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { getCleanUrlPath } from '@shared/helpers';

const getActiveTab = (tabs, baseHref) => {
	const _activeTab = tabs.find((tab) => {
		const link = baseHref + tab.link;
		return (
			getCleanUrlPath(location.pathname.toLowerCase()) ===
			getCleanUrlPath(link.toLowerCase())
		);
	});
	return _activeTab
		? {
				..._activeTab,
				fullLink: baseHref + _activeTab.link,
			}
		: null;
};

export const useNavtabs = ({ tabs, baseHref = '', onTabChange }) => {
	const location = useLocation();
	const [activeTab, setActiveTab] = useState();
	const navigate = useNavigate();

	useLayoutEffect(() => {
		const _activeTab = getActiveTab(tabs, baseHref);
		if (_activeTab) {
			setActiveTab((_previousActive) => {
				if (!_previousActive) {
					// triggers only on first load
					onTabChange?.(_activeTab.key);
				}
				return _activeTab.key;
			});

			if (getCleanUrlPath(location.pathname) !== _activeTab.fullLink) {
				navigate(_activeTab.fullLink, { replace: true });
			}
		} else if (
			getCleanUrlPath(location.pathname.toLowerCase()) ===
			getCleanUrlPath(baseHref?.toLowerCase())
		) {
			navigate(`${baseHref}${tabs[0].link}`, { replace: true });
		}
	}, [location, tabs, baseHref, onTabChange, navigate]);

	return { activeTab };
};
